import React, { useEffect, useState } from 'react'
import { useStateContext } from '../contexts/ContextProvider';

const Button = ({ icon, width, color, size, text, textAr, textColor, onClick }) => {
  const { setToken, user, } = useStateContext();
  const [libelleAr, setLibelleAr] = useState('');
  
  useEffect(() => {
    if (text === 'Save') {
      setLibelleAr('حفظ');
    }
    if (text === 'Colse') {
      setLibelleAr('إغلاق');
    }
    if (text === 'Search') {
      setLibelleAr('بحث');
    }
    if (text === 'Export') {
      setLibelleAr('تحميل');
    }
    if (text === 'Journal') {
      setLibelleAr('السجل المخالصات');
    }
    if (text === 'Bilan') {
      setLibelleAr('الحالة المالية');
    }
    if (text === 'Login') {
      setLibelleAr('تسجيل الدخول');
    }
    if (text === 'New') {
      setLibelleAr('إضافة');
    }

    if (text === 'Print') {
      setLibelleAr('سحــب');
    }
    if (text === 'Cloturer') {
      setLibelleAr('موافقة');
    }
    if (text === 'Noter') {
      setLibelleAr('حفظ');
    }

  },[])
  return (
    // <button type='button' style={{ backgroundColor:bgColor,color,borderRadius }} 
    // className={`text-${size} p-3 hover:drop-shadow-xl`}>
    //   {text}
    // </button>"bg-blue-500 hover:shadow-xl text-white font-bold py-2 px-2  rounded inline-flex items-center"
    <button onClick={onClick} className={`${width} justify-center ${color} text-${size} hover:shadow-xl ${textColor} font-bold py-2 px-2 rounded inline-flex items-center`}>
      {icon}
      
        {
          user.langue === 'AR' ?
            <span className='ml-1'>{libelleAr}</span>
            :
            <span className='ml-1'>{text}</span>
        }
      
    </button>
  )
}

export default Button
